// /src/GuitarSimulator/chordDefinitions.js

// 코드 정의 (프렛 포지션으로 정의) - 전체 코드 체계 (손가락 번호 포함)
// string: 1=1현(E4,가장높은음), 2=2현(B3), 3=3현(G3), 4=4현(D3), 5=5현(A2), 6=6현(E2,가장낮은음)
// finger: 0=개방현, 1=검지, 2=중지, 3=약지, 4=새끼, bar=바레코드
// primary: true=기본포지션(초록색), false=대체포지션(분홍색)
export const chordDefinitions = {
  // ===== 메이저 코드 =====
  'C': [
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'D': [
    {string: 1, fret: 2, finger: 2, primary: true}, // 1현 2프렛
    {string: 2, fret: 3, finger: 3, primary: true}, // 2현 3프렛
    {string: 3, fret: 2, finger: 1, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'E': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 1, finger: 1, primary: true}, // 3현 1프렛
    {string: 4, fret: 2, finger: 3, primary: true}, // 4현 2프렛
    {string: 5, fret: 2, finger: 2, primary: true}, // 5현 2프렛
    {string: 6, fret: 0, finger: 0, primary: true}  // 6현 개방
  ],
  'F': [
    {string: 1, fret: 1, finger: 1, bar: true, primary: true}, // 1현 1프렛 (바레)
    {string: 2, fret: 1, finger: 1, bar: true, primary: true}, // 2현 1프렛 (바레)
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 3, finger: 4, primary: true}, // 4현 3프렛
    {string: 5, fret: 3, finger: 3, primary: true}, // 5현 3프렛
    {string: 6, fret: 1, finger: 1, bar: true, primary: true}  // 6현 1프렛 (바레)
  ],
  'G': [
    {string: 1, fret: 3, finger: 4, primary: true}, // 1현 3프렛
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 0, finger: 0, primary: true}, // 4현 개방
    {string: 5, fret: 2, finger: 1, primary: true}, // 5현 2프렛
    {string: 6, fret: 3, finger: 2, primary: true}  // 6현 3프렛
  ],
  'A': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 2, finger: 3, primary: true}, // 2현 2프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 2, finger: 1, primary: true}, // 4현 2프렛
    {string: 5, fret: 0, finger: 0, primary: true}  // 5현 개방
  ],
  'B': [
    {string: 1, fret: 2, finger: 1, bar: true, primary: true}, // 1현 2프렛 (바레)
    {string: 2, fret: 4, finger: 2, primary: true}, // 2현 4프렛
    {string: 3, fret: 4, finger: 4, primary: true}, // 3현 4프렛
    {string: 4, fret: 4, finger: 3, primary: true}, // 4현 4프렛
    {string: 5, fret: 2, finger: 1, bar: true, primary: true}, // 5현 2프렛 (바레)
    {string: 6, fret: 2, finger: 1, bar: true, primary: true}  // 6현 2프렛 (바레)
  ],

  // ===== 마이너 코드 =====
  'Am': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 2, finger: 3, primary: true}, // 3현 2프렛
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 0, finger: 0, primary: true}  // 5현 개방
  ],
  'Dm': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 3, finger: 3, primary: true}, // 2현 3프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'Em': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 2, finger: 3, primary: true}, // 4현 2프렛
    {string: 5, fret: 2, finger: 2, primary: true}, // 5현 2프렛
    {string: 6, fret: 0, finger: 0, primary: true}  // 6현 개방
  ],
  'Fm': [
    {string: 1, fret: 1, finger: 1, bar: true, primary: true}, // 1현 1프렛 (바레)
    {string: 2, fret: 1, finger: 1, bar: true, primary: true}, // 2현 1프렛 (바레)
    {string: 3, fret: 1, finger: 1, bar: true, primary: true}, // 3현 1프렛 (바레)
    {string: 4, fret: 3, finger: 4, primary: true}, // 4현 3프렛
    {string: 5, fret: 3, finger: 3, primary: true}, // 5현 3프렛
    {string: 6, fret: 1, finger: 1, bar: true, primary: true}  // 6현 1프렛 (바레)
  ],
  'Gm': [
    {string: 1, fret: 3, finger: 1, bar: true, primary: true}, // 1현 3프렛 (바레)
    {string: 2, fret: 3, finger: 1, bar: true, primary: true}, // 2현 3프렛 (바레)
    {string: 3, fret: 3, finger: 1, bar: true, primary: true}, // 3현 3프렛 (바레)
    {string: 4, fret: 5, finger: 4, primary: true}, // 4현 5프렛
    {string: 5, fret: 5, finger: 3, primary: true}, // 5현 5프렛
    {string: 6, fret: 3, finger: 1, bar: true, primary: true}  // 6현 3프렛 (바레)
  ],
  'Cm': [
    {string: 1, fret: 3, finger: 1, bar: true, primary: true}, // 1현 3프렛 (바레)
    {string: 2, fret: 4, finger: 2, primary: true}, // 2현 4프렛
    {string: 3, fret: 5, finger: 4, primary: true}, // 3현 5프렛
    {string: 4, fret: 5, finger: 3, primary: true}, // 4현 5프렛
    {string: 5, fret: 3, finger: 1, bar: true, primary: true}, // 5현 3프렛 (바레)
    {string: 6, fret: 3, finger: 1, bar: true, primary: true}  // 6현 3프렛 (바레)
  ],
  'Bm': [
    {string: 1, fret: 2, finger: 1, bar: true, primary: true}, // 1현 2프렛 (바레)
    {string: 2, fret: 3, finger: 2, primary: true}, // 2현 3프렛
    {string: 3, fret: 4, finger: 4, primary: true}, // 3현 4프렛
    {string: 4, fret: 4, finger: 3, primary: true}, // 4현 4프렛
    {string: 5, fret: 2, finger: 1, bar: true, primary: true}, // 5현 2프렛 (바레)
    {string: 6, fret: 2, finger: 1, bar: true, primary: true}  // 6현 2프렛 (바레)
  ],

  // ===== 3화음 (Triads) =====
  'Cdim': [
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 1, finger: 1, primary: true}, // 4현 1프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'Ddim': [
    {string: 1, fret: 1, finger: 2, primary: true}, // 1현 1프렛
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 1, finger: 1, primary: true}, // 3현 1프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'Edim': [
    {string: 1, fret: 2, finger: 3, primary: true}, // 1현 2프렛
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 1, finger: 1, primary: true}  // 4현 1프렛
  ],
  'Fdim': [
    {string: 1, fret: 1, finger: 3, primary: true}, // 1현 1프렛
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 1, finger: 1, primary: true}  // 4현 1프렛
  ],
  'Gdim': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 3, finger: 4, primary: true}, // 2현 3프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 3, finger: 3, primary: true}  // 4현 3프렛
  ],
  'Adim': [
    {string: 1, fret: 2, finger: 3, primary: true}, // 1현 2프렛
    {string: 2, fret: 1, finger: 2, primary: true}, // 2현 1프렛
    {string: 3, fret: 1, finger: 1, primary: true}  // 3현 1프렛
  ],
  'Bdim': [
    {string: 1, fret: 3, finger: 4, primary: true}, // 1현 3프렛
    {string: 2, fret: 2, finger: 1, primary: true}, // 2현 2프렛
    {string: 3, fret: 3, finger: 3, primary: true}, // 3현 3프렛
    {string: 4, fret: 2, finger: 2, primary: true}  // 4현 2프렛
  ],
  'C+': [
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 1, finger: 1, primary: true}, // 3현 1프렛
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'D+': [
    {string: 1, fret: 2, finger: 1, primary: true}, // 1현 2프렛
    {string: 2, fret: 3, finger: 3, primary: true}, // 2현 3프렛
    {string: 3, fret: 3, finger: 2, primary: true}, // 3현 3프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'E+': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 1, finger: 1, primary: true}, // 3현 1프렛
    {string: 4, fret: 2, finger: 3, primary: true}, // 4현 2프렛
    {string: 5, fret: 2, finger: 2, primary: true}  // 5현 2프렛
  ],
  'F+': [
    {string: 1, fret: 2, finger: 2, primary: true}, // 1현 2프렛
    {string: 2, fret: 2, finger: 2, primary: true}, // 2현 2프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 3, finger: 4, primary: true}, // 4현 3프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'G+': [
    {string: 1, fret: 3, finger: 4, primary: true}, // 1현 3프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}, // 4현 개방
    {string: 6, fret: 3, finger: 3, primary: true}  // 6현 3프렛
  ],
  'A+': [
    {string: 1, fret: 2, finger: 3, primary: true}, // 1현 2프렛
    {string: 2, fret: 3, finger: 2, primary: true}, // 2현 3프렛
    {string: 3, fret: 2, finger: 1, primary: true}  // 3현 2프렛
  ],
  'B+': [
    {string: 1, fret: 5, finger: 2, primary: true}, // 1현 5프렛
    {string: 2, fret: 4, finger: 4, primary: true}, // 2현 4프렛
    {string: 3, fret: 4, finger: 3, primary: true}, // 3현 4프렛
    {string: 4, fret: 2, finger: 1, primary: true}  // 4현 2프렛
  ],

  // ===== 7화음 (Seventh Chords) =====
  'C7': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'D7': [
    {string: 1, fret: 2, finger: 3, primary: true}, // 1현 2프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'E7': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 1, finger: 1, primary: true}, // 3현 1프렛
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 0, finger: 0, primary: true}, // 5현 개방
    {string: 6, fret: 0, finger: 0, primary: true}  // 6현 개방
  ],
  'F7': [
    {string: 1, fret: 1, finger: 1, bar: true, primary: true}, // 1현 1프렛 (바레)
    {string: 2, fret: 1, finger: 1, bar: true, primary: true}, // 2현 1프렛 (바레)
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 3, finger: 4, primary: true}, // 4현 3프렛
    {string: 5, fret: 3, finger: 3, primary: true}, // 5현 3프렛
    {string: 6, fret: 1, finger: 1, bar: true, primary: true}  // 6현 1프렛 (바레)
  ],
  'G7': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 0, finger: 0, primary: true}, // 4현 개방
    {string: 5, fret: 2, finger: 2, primary: true}, // 5현 2프렛
    {string: 6, fret: 3, finger: 3, primary: true}  // 6현 3프렛
  ],
  'A7': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 2, finger: 1, primary: true}, // 2현 2프렛
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 0, finger: 0, primary: true}  // 5현 개방
  ],
  'B7': [
    {string: 1, fret: 2, finger: 1, bar: true, primary: true}, // 1현 2프렛 (바레)
    {string: 2, fret: 2, finger: 3, primary: true}, // 2현 2프렛
    {string: 3, fret: 1, finger: 2, primary: true}, // 3현 1프렛
    {string: 5, fret: 2, finger: 1, bar: true, primary: true}, // 5현 2프렛 (바레)
    {string: 6, fret: 2, finger: 1, bar: true, primary: true}  // 6현 2프렛 (바레)
  ],
  'Cmaj7': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'Dmaj7': [
    {string: 1, fret: 2, finger: 3, primary: true}, // 1현 2프렛
    {string: 2, fret: 2, finger: 2, primary: true}, // 2현 2프렛
    {string: 3, fret: 2, finger: 1, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'Emaj7': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 1, finger: 1, primary: true}, // 3현 1프렛
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 0, finger: 0, primary: true}  // 5현 개방
  ],
  'Fmaj7': [
    {string: 1, fret: 1, finger: 1, bar: true, primary: true}, // 1현 1프렛 (바레)
    {string: 2, fret: 2, finger: 2, primary: true}, // 2현 2프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 3, finger: 3, primary: true}, // 4현 3프렛
    {string: 6, fret: 1, finger: 1, bar: true, primary: true}  // 6현 1프렛 (바레)
  ],
  'Gmaj7': [
    {string: 1, fret: 2, finger: 1, primary: true}, // 1현 2프렛
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 0, finger: 0, primary: true}, // 4현 개방
    {string: 5, fret: 0, finger: 0, primary: true}, // 5현 개방
    {string: 6, fret: 3, finger: 3, primary: true}  // 6현 3프렛
  ],
  'Amaj7': [
    {string: 1, fret: 2, finger: 3, primary: true}, // 1현 2프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 5, fret: 0, finger: 0, primary: true}  // 5현 개방
  ],
  'Bmaj7': [
    {string: 1, fret: 4, finger: 4, primary: true}, // 1현 4프렛
    {string: 2, fret: 3, finger: 2, primary: true}, // 2현 3프렛
    {string: 3, fret: 4, finger: 3, primary: true}, // 3현 4프렛
    {string: 5, fret: 2, finger: 1, bar: true, primary: true}, // 5현 2프렛 (바레)
    {string: 6, fret: 2, finger: 1, bar: true, primary: true}  // 6현 2프렛 (바레)
  ],
  'Cm7': [
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 3, finger: 4, primary: true}, // 3현 3프렛
    {string: 4, fret: 1, finger: 1, primary: true}, // 4현 1프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'Dm7': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'Em7': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 0, finger: 0, primary: true}, // 5현 개방
    {string: 6, fret: 0, finger: 0, primary: true}  // 6현 개방
  ],
  'Fm7': [
    {string: 1, fret: 1, finger: 1, bar: true, primary: true}, // 1현 1프렛 (바레)
    {string: 2, fret: 1, finger: 1, bar: true, primary: true}, // 2현 1프렛 (바레)
    {string: 3, fret: 1, finger: 1, bar: true, primary: true}, // 3현 1프렛 (바레)
    {string: 4, fret: 1, finger: 1, bar: true, primary: true}, // 4현 1프렛 (바레)
    {string: 5, fret: 3, finger: 3, primary: true}, // 5현 3프렛
    {string: 6, fret: 1, finger: 1, bar: true, primary: true}  // 6현 1프렛 (바레)
  ],
  'Gm7': [
    {string: 1, fret: 3, finger: 1, bar: true, primary: true}, // 1현 3프렛 (바레)
    {string: 2, fret: 3, finger: 1, bar: true, primary: true}, // 2현 3프렛 (바레)
    {string: 3, fret: 3, finger: 1, bar: true, primary: true}, // 3현 3프렛 (바레)
    {string: 4, fret: 3, finger: 1, bar: true, primary: true}, // 4현 3프렛 (바레)
    {string: 5, fret: 3, finger: 1, bar: true, primary: true}, // 5현 3프렛 (바레)
    {string: 6, fret: 3, finger: 1, bar: true, primary: true}  // 6현 3프렛 (바레)
  ],
  'Am7': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 0, finger: 0, primary: true}  // 5현 개방
  ],
  'Bm7': [
    {string: 1, fret: 2, finger: 1, bar: true, primary: true}, // 1현 2프렛 (바레)
    {string: 2, fret: 2, finger: 1, bar: true, primary: true}, // 2현 2프렛 (바레)
    {string: 3, fret: 2, finger: 1, bar: true, primary: true}, // 3현 2프렛 (바레)
    {string: 4, fret: 2, finger: 1, bar: true, primary: true}, // 4현 2프렛 (바레)
    {string: 5, fret: 2, finger: 1, bar: true, primary: true}, // 5현 2프렛 (바레)
    {string: 6, fret: 2, finger: 1, bar: true, primary: true}  // 6현 2프렛 (바레)
  ],
  'CmMaj7': [
    {string: 1, fret: 3, finger: 1, primary: true}, // 1현 3프렛
    {string: 2, fret: 4, finger: 2, primary: true}, // 2현 4프렛
    {string: 3, fret: 5, finger: 4, primary: true}, // 3현 5프렛
    {string: 4, fret: 3, finger: 3, primary: true}  // 4현 3프렛
  ],
  'DmMaj7': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 2, finger: 3, primary: true}, // 2현 2프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'EmMaj7': [
    {string: 1, fret: 4, finger: 4, primary: true}, // 1현 4프렛
    {string: 2, fret: 2, finger: 1, primary: true}, // 2현 2프렛
    {string: 3, fret: 3, finger: 3, primary: true}, // 3현 3프렛
    {string: 4, fret: 4, finger: 4, primary: true}, // 4현 4프렛
    {string: 5, fret: 0, finger: 0, primary: true}  // 5현 개방
  ],
  'Cdim7': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 3, finger: 4, primary: true}, // 3현 3프렛
    {string: 4, fret: 1, finger: 1, primary: true}, // 4현 1프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'Ddim7': [
    {string: 1, fret: 1, finger: 2, primary: true}, // 1현 1프렛
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 1, finger: 1, primary: true}, // 3현 1프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'Edim7': [
    {string: 1, fret: 2, finger: 3, primary: true}, // 1현 2프렛
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 1, finger: 1, primary: true}  // 4현 1프렛
  ],
  'Cm7b5': [
    {string: 1, fret: 4, finger: 1, primary: true}, // 1현 4프렛
    {string: 2, fret: 3, finger: 2, primary: true}, // 2현 3프렛
    {string: 3, fret: 4, finger: 4, primary: true}, // 3현 4프렛
    {string: 4, fret: 3, finger: 3, primary: true}  // 4현 3프렛
  ],
  'Dm7b5': [
    {string: 1, fret: 1, finger: 3, primary: true}, // 1현 1프렛
    {string: 2, fret: 1, finger: 2, primary: true}, // 2현 1프렛
    {string: 3, fret: 1, finger: 1, primary: true}, // 3현 1프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'Em7b5': [
    {string: 1, fret: 3, finger: 1, primary: true}, // 1현 3프렛
    {string: 2, fret: 3, finger: 4, primary: true}, // 2현 3프렛
    {string: 3, fret: 3, finger: 3, primary: true}, // 3현 3프렛
    {string: 4, fret: 2, finger: 2, primary: true}  // 4현 2프렛
  ],

  // ===== 확장 코드 (Extended) =====
  'C9': [
    {string: 1, fret: 3, finger: 3, primary: true}, // 1현 3프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 3, finger: 4, primary: true}, // 3현 3프렛
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'D9': [
    {string: 1, fret: 5, finger: 3, primary: true}, // 1현 5프렛
    {string: 2, fret: 3, finger: 1, primary: true}, // 2현 3프렛
    {string: 3, fret: 5, finger: 4, primary: true}, // 3현 5프렛
    {string: 4, fret: 4, finger: 2, primary: true}, // 4현 4프렛
    {string: 5, fret: 5, finger: 3, primary: true}  // 5현 5프렛
  ],
  'E9': [
    {string: 1, fret: 2, finger: 2, primary: true}, // 1현 2프렛
    {string: 2, fret: 2, finger: 2, primary: true}, // 2현 2프렛
    {string: 3, fret: 2, finger: 1, primary: true}, // 3현 2프렛
    {string: 4, fret: 4, finger: 3, primary: true}, // 4현 4프렛
    {string: 5, fret: 4, finger: 4, primary: true}  // 5현 4프렛
  ],
  'G9': [
    {string: 1, fret: 3, finger: 4, primary: true}, // 1현 3프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 0, finger: 0, primary: true}, // 4현 개방
    {string: 5, fret: 2, finger: 2, primary: true}, // 5현 2프렛
    {string: 6, fret: 3, finger: 3, primary: true}  // 6현 3프렛
  ],
  'A9': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 2, finger: 1, primary: true}, // 4현 2프렛
    {string: 5, fret: 2, finger: 2, primary: true}  // 5현 2프렛
  ],
  'Cm9': [
    {string: 1, fret: 3, finger: 1, bar: true, primary: true}, // 1현 3프렛 (바레)
    {string: 2, fret: 3, finger: 1, bar: true, primary: true}, // 2현 3프렛 (바레)
    {string: 3, fret: 3, finger: 1, bar: true, primary: true}, // 3현 3프렛 (바레)
    {string: 4, fret: 3, finger: 1, bar: true, primary: true}, // 4현 3프렛 (바레)
    {string: 5, fret: 3, finger: 1, bar: true, primary: true}, // 5현 3프렛 (바레)
    {string: 6, fret: 3, finger: 1, bar: true, primary: true}  // 6현 3프렛 (바레)
  ],
  'Dm9': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'Em9': [
    {string: 1, fret: 2, finger: 3, primary: true}, // 1현 2프렛
    {string: 2, fret: 2, finger: 1, primary: true}, // 2현 2프렛
    {string: 3, fret: 2, finger: 4, primary: true}, // 3현 2프렛
    {string: 4, fret: 4, finger: 2, primary: true}  // 4현 4프렛
  ],
  'Am9': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 2, finger: 1, primary: true}, // 4현 2프렛
    {string: 5, fret: 2, finger: 2, primary: true}  // 5현 2프렛
  ],
  'C11': [
    {string: 1, fret: 3, finger: 3, primary: true}, // 1현 3프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 3, finger: 3, primary: true}, // 3현 3프렛
    {string: 4, fret: 3, finger: 3, primary: true}, // 4현 3프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'D11': [
    {string: 1, fret: 5, finger: 1, bar: true, primary: true}, // 1현 5프렛 (바레)
    {string: 2, fret: 5, finger: 1, bar: true, primary: true}, // 2현 5프렛 (바레)
    {string: 3, fret: 5, finger: 1, bar: true, primary: true}, // 3현 5프렛 (바레)
    {string: 4, fret: 5, finger: 1, bar: true, primary: true}, // 4현 5프렛 (바레)
    {string: 5, fret: 5, finger: 1, bar: true, primary: true}, // 5현 5프렛 (바레)
    {string: 6, fret: 5, finger: 1, bar: true, primary: true}  // 6현 5프렛 (바레)
  ],
  'G11': [
    {string: 1, fret: 3, finger: 3, primary: true}, // 1현 3프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 3, finger: 3, primary: true}, // 3현 3프렛
    {string: 4, fret: 3, finger: 3, primary: true}, // 4현 3프렛
    {string: 5, fret: 3, finger: 3, primary: true}, // 5현 3프렛
    {string: 6, fret: 3, finger: 3, primary: true}  // 6현 3프렛
  ],
  'C13': [
    {string: 1, fret: 3, finger: 3, primary: true}, // 1현 3프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 3, finger: 2, primary: true}, // 3현 3프렛
    {string: 4, fret: 5, finger: 4, primary: true}, // 4현 5프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'D13': [
    {string: 1, fret: 3, finger: 1, primary: true}, // 1현 3프렛
    {string: 2, fret: 3, finger: 3, primary: true}, // 2현 3프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'G13': [
    {string: 1, fret: 3, finger: 4, primary: true}, // 1현 3프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 0, finger: 0, primary: true}, // 4현 개방
    {string: 5, fret: 0, finger: 0, primary: true}, // 5현 개방
    {string: 6, fret: 3, finger: 3, primary: true}  // 6현 3프렛
  ],

  // ===== 변형 코드 (Altered) =====
  'Csus2': [
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 0, finger: 0, primary: true}, // 4현 개방
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'Dsus2': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 3, finger: 3, primary: true}, // 2현 3프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'Esus2': [
    {string: 1, fret: 4, finger: 3, primary: true}, // 1현 4프렛
    {string: 2, fret: 4, finger: 4, primary: true}, // 2현 4프렛
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 0, finger: 0, primary: true}  // 5현 개방
  ],
  'Gsus2': [
    {string: 1, fret: 3, finger: 2, primary: true}, // 1현 3프렛
    {string: 2, fret: 3, finger: 4, primary: true}, // 2현 3프렛
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 5, fret: 0, finger: 0, primary: true}, // 5현 개방
    {string: 6, fret: 3, finger: 3, primary: true}  // 6현 3프렛
  ],
  'Asus2': [
    {string: 1, fret: 2, finger: 1, primary: true}, // 1현 2프렛
    {string: 2, fret: 2, finger: 2, primary: true}, // 2현 2프렛
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 5, fret: 0, finger: 0, primary: true}  // 5현 개방
  ],
  'Csus4': [
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 3, finger: 3, primary: true}, // 4현 3프렛
    {string: 5, fret: 3, finger: 4, primary: true}  // 5현 3프렛
  ],
  'Dsus4': [
    {string: 1, fret: 3, finger: 2, primary: true}, // 1현 3프렛
    {string: 2, fret: 3, finger: 3, primary: true}, // 2현 3프렛
    {string: 3, fret: 2, finger: 1, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'Esus4': [
    {string: 1, fret: 2, finger: 1, primary: true}, // 1현 2프렛
    {string: 2, fret: 2, finger: 3, primary: true}, // 2현 2프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}, // 4현 개방
    {string: 5, fret: 0, finger: 0, primary: true}, // 5현 개방
    {string: 6, fret: 0, finger: 0, primary: true}  // 6현 개방
  ],
  'Fsus4': [
    {string: 1, fret: 1, finger: 1, bar: true, primary: true}, // 1현 1프렛 (바레)
    {string: 2, fret: 1, finger: 1, bar: true, primary: true}, // 2현 1프렛 (바레)
    {string: 3, fret: 3, finger: 2, primary: true}, // 3현 3프렛
    {string: 4, fret: 3, finger: 4, primary: true}, // 4현 3프렛
    {string: 5, fret: 3, finger: 3, primary: true}, // 5현 3프렛
    {string: 6, fret: 1, finger: 1, bar: true, primary: true}  // 6현 1프렛 (바레)
  ],
  'Gsus4': [
    {string: 1, fret: 1, finger: 2, primary: true}, // 1현 1프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 3, finger: 4, primary: true}, // 4현 3프렛
    {string: 5, fret: 3, finger: 3, primary: true}, // 5현 3프렛
    {string: 6, fret: 0, finger: 0, primary: true}  // 6현 개방
  ],
  'Asus4': [
    {string: 1, fret: 3, finger: 1, primary: true}, // 1현 3프렛
    {string: 2, fret: 2, finger: 3, primary: true}, // 2현 2프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 5, fret: 0, finger: 0, primary: true}  // 5현 개방
  ],
  'Cadd9': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'Dadd9': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 3, finger: 3, primary: true}, // 2현 3프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'Gadd9': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 3, finger: 4, primary: true}, // 2현 3프렛
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 0, finger: 0, primary: true}, // 4현 개방
    {string: 5, fret: 2, finger: 3, primary: true}, // 5현 2프렛
    {string: 6, fret: 3, finger: 2, primary: true}  // 6현 3프렛
  ],
  'Fadd9': [
    {string: 1, fret: 1, finger: 1, bar: true, primary: true}, // 1현 1프렛 (바레)
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 3, finger: 3, primary: true}, // 4현 3프렛
    {string: 6, fret: 1, finger: 1, bar: true, primary: true}  // 6현 1프렛 (바레)
  ],
  'C7#9': [
    {string: 1, fret: 4, finger: 1, primary: true}, // 1현 4프렛
    {string: 2, fret: 3, finger: 2, primary: true}, // 2현 3프렛
    {string: 3, fret: 4, finger: 4, primary: true}, // 3현 4프렛
    {string: 4, fret: 2, finger: 3, primary: true}, // 4현 2프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'D7#9': [
    {string: 1, fret: 7, finger: 1, primary: true}, // 1현 7프렛
    {string: 2, fret: 5, finger: 2, primary: true}, // 2현 5프렛
    {string: 3, fret: 6, finger: 4, primary: true}, // 3현 6프렛
    {string: 4, fret: 5, finger: 3, primary: true}, // 4현 5프렛
    {string: 5, fret: 5, finger: 3, primary: true}  // 5현 5프렛
  ],
  'G7#9': [
    {string: 1, fret: 4, finger: 1, primary: true}, // 1현 4프렛
    {string: 2, fret: 3, finger: 2, primary: true}, // 2현 3프렛
    {string: 3, fret: 4, finger: 4, primary: true}, // 3현 4프렛
    {string: 4, fret: 3, finger: 3, primary: true}  // 4현 3프렛
  ],
  'C7b9': [
    {string: 1, fret: 3, finger: 1, primary: true}, // 1현 3프렛
    {string: 2, fret: 2, finger: 2, primary: true}, // 2현 2프렛
    {string: 3, fret: 4, finger: 4, primary: true}, // 3현 4프렛
    {string: 4, fret: 2, finger: 3, primary: true}, // 4현 2프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'D7b9': [
    {string: 1, fret: 7, finger: 1, primary: true}, // 1현 7프렛
    {string: 2, fret: 4, finger: 2, primary: true}, // 2현 4프렛
    {string: 3, fret: 6, finger: 4, primary: true}, // 3현 6프렛
    {string: 4, fret: 5, finger: 3, primary: true}, // 4현 5프렛
    {string: 5, fret: 5, finger: 3, primary: true}  // 5현 5프렛
  ],
  'G7b9': [
    {string: 1, fret: 3, finger: 1, primary: true}, // 1현 3프렛
    {string: 2, fret: 3, finger: 2, primary: true}, // 2현 3프렛
    {string: 3, fret: 4, finger: 4, primary: true}, // 3현 4프렛
    {string: 4, fret: 3, finger: 3, primary: true}  // 4현 3프렛
  ],
  'C7#5': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 2, finger: 1, primary: true}, // 2현 2프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 2, finger: 3, primary: true}, // 4현 2프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'D7#5': [
    {string: 1, fret: 3, finger: 3, primary: true}, // 1현 3프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'G7#5': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 1, finger: 1, primary: true}, // 3현 1프렛
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 6, fret: 3, finger: 3, primary: true}  // 6현 3프렛
  ],

  // ===== 특수 코드 (Special) =====
  'C5': [
    {string: 2, fret: 5, finger: 1, primary: true}, // 2현 5프렛
    {string: 3, fret: 3, finger: 3, primary: true}  // 3현 3프렛
  ],
  'D5': [
    {string: 2, fret: 7, finger: 1, primary: true}, // 2현 7프렛
    {string: 3, fret: 5, finger: 3, primary: true}  // 3현 5프렛
  ],
  'E5': [
    {string: 5, fret: 2, finger: 1, primary: true}, // 5현 2프렛
    {string: 6, fret: 0, finger: 0, primary: true}  // 6현 개방
  ],
  'F5': [
    {string: 4, fret: 3, finger: 3, primary: true}, // 4현 3프렛
    {string: 5, fret: 1, finger: 1, primary: true}  // 5현 1프렛
  ],
  'G5': [
    {string: 5, fret: 5, finger: 1, primary: true}, // 5현 5프렛
    {string: 6, fret: 3, finger: 3, primary: true}  // 6현 3프렛
  ],
  'A5': [
    {string: 5, fret: 7, finger: 1, primary: true}, // 5현 7프렛
    {string: 6, fret: 5, finger: 3, primary: true}  // 6현 5프렛
  ],
  'B5': [
    {string: 4, fret: 4, finger: 1, primary: true}, // 4현 4프렛
    {string: 5, fret: 2, finger: 2, primary: true}  // 5현 2프렛
  ],
  'C/E': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 3, finger: 3, primary: true}, // 5현 3프렛
    {string: 6, fret: 0, finger: 0, primary: true}  // 6현 개방
  ],
  'C/G': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 3, finger: 4, primary: true}, // 2현 3프렛
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 3, finger: 3, primary: true}, // 5현 3프렛
    {string: 6, fret: 3, finger: 3, primary: true}  // 6현 3프렛
  ],
  'D/F#': [
    {string: 1, fret: 2, finger: 3, primary: true}, // 1현 2프렛
    {string: 2, fret: 3, finger: 4, primary: true}, // 2현 3프렛
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}, // 4현 개방
    {string: 6, fret: 2, finger: 1, primary: true}  // 6현 2프렛
  ],
  'G/B': [
    {string: 1, fret: 3, finger: 3, primary: true}, // 1현 3프렛
    {string: 2, fret: 3, finger: 4, primary: true}, // 2현 3프렛
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 0, finger: 0, primary: true}, // 4현 개방
    {string: 5, fret: 2, finger: 1, primary: true}  // 5현 2프렛
  ],
  'Am/C': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 2, finger: 4, primary: true}, // 3현 2프렛
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'C6': [
    {string: 1, fret: 1, finger: 1, primary: true}, // 1현 1프렛
    {string: 2, fret: 1, finger: 1, primary: true}, // 2현 1프렛
    {string: 3, fret: 2, finger: 1, primary: true}, // 3현 2프렛
    {string: 4, fret: 2, finger: 2, primary: true}, // 4현 2프렛
    {string: 5, fret: 3, finger: 3, primary: true}  // 5현 3프렛
  ],
  'D6': [
    {string: 1, fret: 2, finger: 1, primary: true}, // 1현 2프렛
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 2, finger: 2, primary: true}, // 3현 2프렛
    {string: 4, fret: 0, finger: 0, primary: true}  // 4현 개방
  ],
  'G6': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 0, finger: 0, primary: true}, // 3현 개방
    {string: 4, fret: 3, finger: 2, primary: true}, // 4현 3프렛
    {string: 5, fret: 0, finger: 0, primary: true}, // 5현 개방
    {string: 6, fret: 3, finger: 3, primary: true}  // 6현 3프렛
  ],
  'Am6': [
    {string: 1, fret: 0, finger: 0, primary: true}, // 1현 개방
    {string: 2, fret: 0, finger: 0, primary: true}, // 2현 개방
    {string: 3, fret: 2, finger: 3, primary: true}, // 3현 2프렛
    {string: 4, fret: 2, finger: 2, primary: true}  // 4현 2프렛
  ]
};

// 코드의 대체 포지션 정의 (같은 코드를 다른 방법으로 잡기)
export const alternativeChordPositions = {
  'C': [
    // 8프렛 바레 포지션
    {string: 1, fret: 8, finger: 1, bar: true, primary: false}, // 1현 8프렛 (바레)
    {string: 2, fret: 8, finger: 1, bar: true, primary: false}, // 2현 8프렛 (바레)
    {string: 3, fret: 9, finger: 2, primary: false}, // 3현 9프렛
    {string: 4, fret: 10, finger: 4, primary: false}, // 4현 10프렛
    {string: 5, fret: 8, finger: 3, primary: false}, // 5현 8프렛
    {string: 6, fret: 8, finger: 1, bar: true, primary: false}  // 6현 8프렛 (바레)
  ],
  'D': [
    // 10프렛 바레 포지션
    {string: 1, fret: 10, finger: 1, bar: true, primary: false}, // 1현 10프렛 (바레)
    {string: 2, fret: 10, finger: 1, bar: true, primary: false}, // 2현 10프렛 (바레)
    {string: 3, fret: 11, finger: 2, primary: false}, // 3현 11프렛
    {string: 4, fret: 12, finger: 4, primary: false}, // 4현 12프렛
    {string: 5, fret: 10, finger: 3, primary: false}, // 5현 10프렛
    {string: 6, fret: 10, finger: 1, bar: true, primary: false}  // 6현 10프렛 (바레)
  ],
  'E': [
    // 12프렛 바레 포지션
    {string: 1, fret: 12, finger: 1, bar: true, primary: false}, // 1현 12프렛 (바레)
    {string: 2, fret: 12, finger: 1, bar: true, primary: false}, // 2현 12프렛 (바레)
    {string: 3, fret: 13, finger: 2, primary: false}, // 3현 13프렛
    {string: 4, fret: 14, finger: 4, primary: false}, // 4현 14프렛
    {string: 5, fret: 12, finger: 3, primary: false}, // 5현 12프렛
    {string: 6, fret: 12, finger: 1, bar: true, primary: false}  // 6현 12프렛 (바레)
  ],
  'F': [
    // 8프렛 포지션
    {string: 2, fret: 8, finger: 1, primary: false}, // 2현 8프렛
    {string: 3, fret: 10, finger: 3, primary: false}, // 3현 10프렛
    {string: 4, fret: 10, finger: 4, primary: false}, // 4현 10프렛
    {string: 5, fret: 8, finger: 2, primary: false}  // 5현 8프렛
  ],
  'G': [
    // 3프렛 바레 포지션
    {string: 1, fret: 3, finger: 1, bar: true, primary: false}, // 1현 3프렛 (바레)
    {string: 2, fret: 3, finger: 1, bar: true, primary: false}, // 2현 3프렛 (바레)
    {string: 3, fret: 4, finger: 2, primary: false}, // 3현 4프렛
    {string: 4, fret: 5, finger: 4, primary: false}, // 4현 5프렛
    {string: 5, fret: 5, finger: 3, primary: false}, // 5현 5프렛
    {string: 6, fret: 3, finger: 1, bar: true, primary: false}  // 6현 3프렛 (바레)
  ],
  'A': [
    // 5프렛 바레 포지션
    {string: 1, fret: 5, finger: 1, bar: true, primary: false}, // 1현 5프렛 (바레)
    {string: 2, fret: 5, finger: 1, bar: true, primary: false}, // 2현 5프렛 (바레)
    {string: 3, fret: 6, finger: 2, primary: false}, // 3현 6프렛
    {string: 4, fret: 7, finger: 4, primary: false}, // 4현 7프렛
    {string: 5, fret: 7, finger: 3, primary: false}, // 5현 7프렛
    {string: 6, fret: 5, finger: 1, bar: true, primary: false}  // 6현 5프렛 (바레)
  ],
  'B': [
    // 7프렛 바레 포지션 (E형)
    {string: 1, fret: 7, finger: 1, bar: true, primary: false}, // 1현 7프렛 (바레)
    {string: 2, fret: 7, finger: 1, bar: true, primary: false}, // 2현 7프렛 (바레)
    {string: 3, fret: 8, finger: 2, primary: false}, // 3현 8프렛
    {string: 4, fret: 9, finger: 4, primary: false}, // 4현 9프렛
    {string: 5, fret: 7, finger: 3, primary: false}, // 5현 7프렛
    {string: 6, fret: 7, finger: 1, bar: true, primary: false}  // 6현 7프렛 (바레)
  ],
  'Am': [
    // 5프렛 바레 포지션
    {string: 1, fret: 5, finger: 1, bar: true, primary: false}, // 1현 5프렛 (바레)
    {string: 2, fret: 5, finger: 1, bar: true, primary: false}, // 2현 5프렛 (바레)
    {string: 3, fret: 5, finger: 1, bar: true, primary: false}, // 3현 5프렛 (바레)
    {string: 4, fret: 7, finger: 3, primary: false}, // 4현 7프렛
    {string: 5, fret: 8, finger: 4, primary: false}, // 5현 8프렛
    {string: 6, fret: 5, finger: 1, bar: true, primary: false}  // 6현 5프렛 (바레)
  ],
  'Dm': [
    // 10프렛 포지션
    {string: 2, fret: 12, finger: 4, primary: false}, // 2현 12프렛
    {string: 3, fret: 11, finger: 3, primary: false}, // 3현 11프렛
    {string: 4, fret: 10, finger: 1, primary: false}, // 4현 10프렛
    {string: 5, fret: 10, finger: 2, primary: false}  // 5현 10프렛
  ],
  'Em': [
    // 7프렛 바레 포지션
    {string: 1, fret: 7, finger: 1, bar: true, primary: false}, // 1현 7프렛 (바레)
    {string: 2, fret: 7, finger: 1, bar: true, primary: false}, // 2현 7프렛 (바레)
    {string: 3, fret: 7, finger: 1, bar: true, primary: false}, // 3현 7프렛 (바레)
    {string: 4, fret: 9, finger: 3, primary: false}, // 4현 9프렛
    {string: 5, fret: 10, finger: 4, primary: false}, // 5현 10프렛
    {string: 6, fret: 7, finger: 1, bar: true, primary: false}  // 6현 7프렛 (바레)
  ],
  'Fm': [
    // 8프렛 포지션
    {string: 2, fret: 8, finger: 1, primary: false}, // 2현 8프렛
    {string: 3, fret: 9, finger: 3, primary: false}, // 3현 9프렛
    {string: 4, fret: 10, finger: 4, primary: false}, // 4현 10프렛
    {string: 5, fret: 8, finger: 2, primary: false}  // 5현 8프렛
  ],
  'Gm': [
    // 10프렛 포지션
    {string: 2, fret: 10, finger: 1, primary: false}, // 2현 10프렛
    {string: 3, fret: 11, finger: 3, primary: false}, // 3현 11프렛
    {string: 4, fret: 12, finger: 4, primary: false}, // 4현 12프렛
    {string: 5, fret: 10, finger: 2, primary: false}  // 5현 10프렛
  ],
  'Cm': [
    // 8프렛 바레 포지션
    {string: 1, fret: 8, finger: 1, bar: true, primary: false}, // 1현 8프렛 (바레)
    {string: 2, fret: 8, finger: 1, bar: true, primary: false}, // 2현 8프렛 (바레)
    {string: 3, fret: 8, finger: 1, bar: true, primary: false}, // 3현 8프렛 (바레)
    {string: 4, fret: 10, finger: 3, primary: false}, // 4현 10프렛
    {string: 5, fret: 11, finger: 4, primary: false}, // 5현 11프렛
    {string: 6, fret: 8, finger: 1, bar: true, primary: false}  // 6현 8프렛 (바레)
  ],
  'Bm': [
    // 7프렛 바레 포지션 (Em형)
    {string: 1, fret: 7, finger: 1, bar: true, primary: false}, // 1현 7프렛 (바레)
    {string: 2, fret: 7, finger: 1, bar: true, primary: false}, // 2현 7프렛 (바레)
    {string: 3, fret: 7, finger: 1, bar: true, primary: false}, // 3현 7프렛 (바레)
    {string: 4, fret: 9, finger: 3, primary: false}, // 4현 9프렛
    {string: 5, fret: 10, finger: 4, primary: false}, // 5현 10프렛
    {string: 6, fret: 7, finger: 1, bar: true, primary: false}  // 6현 7프렛 (바레)
  ]
};

// 코드 카테고리별 데이터
export const chordCategories = {
  basic: {
    title: 'KR' ? '기본 코드' : 'Basic Chords',
    chords: [
      'C', 'D', 'E', 'F', 'G', 'A', 'B',
      'Am', 'Dm', 'Em', 'Fm', 'Gm', 'Cm', 'Bm'
    ]
  },
  triads: {
    title: 'KR' ? '3화음' : 'Triads',
    chords: [
      'C', 'D', 'E', 'F', 'G', 'A', 'B', // Major Triads
      'Cm', 'Dm', 'Em', 'Fm', 'Gm', 'Am', 'Bm', // Minor Triads
      'Cdim', 'Ddim', 'Edim', 'Fdim', 'Gdim', 'Adim', 'Bdim', // Diminished
      'C+', 'D+', 'E+', 'F+', 'G+', 'A+', 'B+' // Augmented
    ]
  },
  seventh: {
    title: 'KR' ? '7화음' : 'Seventh Chords',
    chords: [
      'C7', 'D7', 'E7', 'F7', 'G7', 'A7', 'B7', // Dominant 7th
      'Cmaj7', 'Dmaj7', 'Emaj7', 'Fmaj7', 'Gmaj7', 'Amaj7', 'Bmaj7', // Major 7th
      'Cm7', 'Dm7', 'Em7', 'Fm7', 'Gm7', 'Am7', 'Bm7', // Minor 7th
      'CmMaj7', 'DmMaj7', 'EmMaj7', // Minor Major 7th
      'Cdim7', 'Ddim7', 'Edim7', // Diminished 7th
      'Cm7b5', 'Dm7b5', 'Em7b5' // Half Diminished 7th
    ]
  },
  extended: {
    title: 'KR' ? '확장 코드' : 'Extended Chords',
    chords: [
      'C9', 'D9', 'E9', 'G9', 'A9', // 9th Chords
      'Cm9', 'Dm9', 'Em9', 'Am9',
      'C11', 'D11', 'G11', // 11th Chords
      'C13', 'D13', 'G13' // 13th Chords
    ]
  },
  altered: {
    title: 'KR' ? '변형 코드' : 'Altered Chords',
    chords: [
      'Csus2', 'Dsus2', 'Esus2', 'Gsus2', 'Asus2', // Suspended
      'Csus4', 'Dsus4', 'Esus4', 'Fsus4', 'Gsus4', 'Asus4',
      'Cadd9', 'Dadd9', 'Gadd9', 'Fadd9', // Add Chords
      'C7#9', 'D7#9', 'G7#9', // Altered Dominants
      'C7b9', 'D7b9', 'G7b9',
      'C7#5', 'D7#5', 'G7#5'
    ]
  },
  special: {
    title: 'KR' ? '특수 코드' : 'Special Chords',
    chords: [
      'C5', 'D5', 'E5', 'F5', 'G5', 'A5', 'B5', // Power Chords
      'C/E', 'C/G', 'D/F#', 'G/B', 'Am/C', // Slash Chords
      'C6', 'D6', 'G6', 'Am6' // 6th Chords
    ]
  }
};